import {Injectable} from '@angular/core';
import {forkJoin, Observable, of, throwError} from "rxjs";
import {ApiService} from "../api/api.service";
import {catchError, delay, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private api: ApiService) {
  }

  getProfile(): Observable<any> {
    const endpoint = 'user/profile';
    return this.api.get(endpoint).pipe(map(data => data['data']));
  }

  getProfileImage(avatar: string): Observable<any> {
    const endpoint = 'user/image?avatar=' + avatar;
    return this.api.get(endpoint).pipe(map(data => data['data']));
  }

  updateProfile(profileData: any): Observable<any> {
    const endpoint = 'user/profile';
    return this.api.put(endpoint, profileData).pipe(map(res => res['data']));
  }

  postFile(fileToUpload: File): Observable<any> {
    const endpoint = 'your-destination-url';
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload)

    // TODO Delete this
    return of({'new_avatar': 'https://cdn.icon-icons.com/icons2/21/PNG/256/toons_homer_simpson_homersimpson_2381.png'});

    // TODO Uncomment this
    // return this.api
    //   .post(``, formData, {})
    //   .pipe(map(res => res));
  }

  updateEmail(emails: any): Observable<any> {
    const endpoint = 'user/email';
    return this.api.put(endpoint, emails).pipe(map(res => res['data']));
  }

  deprecatedUpdatePassword(passwords: any): Observable<any> {
    const endpoint = 'user/updatePassword';
    return this.api.put(endpoint, passwords).pipe(map(res => res['data']));
  }

  makeEmailPrimary(email: any): Observable<any> {
    const endpoint = 'user/email/makePrimary';
    return this.api.put(endpoint, email).pipe(map(res => res['data']));
  }

  verifyEmail(email: any): Observable<any> {
    const endpoint = 'user/email/triggerVerification';
    return this.api.put(endpoint, email).pipe(map(res => res['data']));
  }

  /**
   * Trigger mobile number verification (sends SMS code).
   * @param countryCode - Country calling code (e.g., "61")
   * @param phoneNumber - Phone number without country code (e.g., "412345678")
   */
  triggerMobileVerification(countryCode: string, phoneNumber: string): Observable<any> {
    const endpoint = 'user/mobile/triggerVerification';
    return this.api.put(endpoint, { country_code: countryCode, phone_number: phoneNumber }).pipe(map(data => data['data']));
  }

  /**
   * Verify mobile number with OTP code.
   * @param mfaCode - The 6-digit OTP code
   */
  verifyMobile(mfaCode: string): Observable<any> {
    const endpoint = 'user/mobile/verify';
    return this.api.post(endpoint, { mfa_code: mfaCode }).pipe(map(data => data['data']));
  }

}
